<template>
    <div class="person-container">
       <div class="person-hero-banner">
           <div class="hero-info">
               <div class="hero-info-text">
               <h1>{{person.name}}</h1>
               <p>{{person.profession}}</p>
               </div>
           </div>
           <div class="hero-background-images">
               <div class="background-hero secondary" :style="{ backgroundImage: `url('../..${person.fullSecondary}')` }"></div>
               <div class="background-hero primary" :style="{ backgroundImage: `url('../..${person.full}')` }"></div>
           </div>
       </div>
       <div class="entry-text">
           <div class="entry-text-content">
               <h2>Hey, I'm {{person.name}}</h2>
               <div class="text-content-copy">
                <div class="text-content-core">
                   <p v-for="(text, index) in person.paragraphs" :key='index'>{{text}}</p>
                   <p class='highlighted-text'>{{person.highlightedText}}</p>
               </div>
               <div class="text-quote">
                   <p>"<span>{{person.quote}}</span>"</p>
               </div>
               </div>

           </div>
       </div>
       <TeamListing></TeamListing>
    </div>
</template>

<script>
import { Team } from '@/assets/js/team-members.js';
import TeamListing from '@/views/supports/TeamListing';
export default {
metaInfo () {
    return {
        titleTemplate: `${this.person.name} - Team Profile | %s`,
        meta: [
          {
            name: `description`,
            content: `${this.person.name} is a ${this.person.profession} at Branton, a creative design agency based in London, Ontario.`
          }
        ]
    }
},
data () {
    return {
        person: null,
        teamMembers: Team
    };
},
components: {
    TeamListing
},
methods:{
    getPerson: function(){
        let vm = this;
        vm.person = vm.teamMembers.find(p => p.url == vm.$route.params.name);
        if(!vm.person){
            vm.$router.push('/');
        }
    }
},
created(){
    this.getPerson();
},
mounted(){
    let imgFile = document.querySelector('.background-hero.secondary');
    // eslint-disable-next-line
    let looper = setInterval(function() { 
        imgFile.classList.toggle('on');
    }, 5000)
},
  watch: {
    // eslint-disable-next-line
    $route(to, from) {
      this.getPerson();
    }
  }
}
</script>

<style lang="scss">
    @import '@/assets/css/team.scss';
</style>
